import api from "./instance";
import socketIo from "socket.io-client";
import {TokenService} from "./tokenService";
import {logout} from "../../redux/auth";
import store from "../../redux/store";

let _sioInstance = null;

export const sioConnect = (token) => {
  _sioInstance = socketIo({reconnection: false}); // socketIo({secure: true});
  _sioInstance.on('connect', () => _sioInstance.emit('sioLogin', token));
  _sioInstance.on('event', (e) => console.log('event', e));
  _sioInstance.on('disconnect', () => store.dispatch(logout()));
}

export const sioDisconnect = () => {
  TokenService.removeUser();
  if( _sioInstance.connected ) {
    _sioInstance.removeEventListener('disconnect', () => console.log('remove disconnect event'));
    _sioInstance.disconnect();
  }
  _sioInstance = null;
}

export const sessionExpiredLogout = () => {
  store.dispatch(logout())
};

export const ApiService = {
	//login & logout
	login : (email, password) => {
		return api.post("/api/v1/auth/login", {
			email: email,
			password : password,
		})
	},

	qrCheck : () => {	//2차 인증 정보 생성(qr코드)
		return api.post("/api/v1/auth/make-auth2")
	},

	updateOtpAuth : (otp) => {	//2차 인증 활성화(qr코드 인증을 한건지 확인)
		return api.post("/api/v1/admins/auth2-enable", otp);
	},

	otpLogin : (otp) => {	//2차 인증 요청(otp 요청)
		return api.post("/api/v1/auth/login2", otp)
	},

	logout : () => {
		sioDisconnect();
		document.location.href = "/";
	},

	//refreshToken
	refreshToken: (accessToken, refreshToken) => {
		return api.post("/api/v1/auth/refresh-token", { refreshToken: refreshToken }, {
			headers : { 'Authorization': `Bearer ${accessToken}`}
		})
	},

	//dashboard
	getDashboardCount : () => {	//대시보드 통계 조회
		return api.get("/api/v1/admins/dashboard/count")
	},
	
	//admin
	getAdminList : () => {	//관리자 정보 조회
		return api.get("/api/v1/admins")
    },

	getAdmin : (id) => {	//마이페이지 조회
		return api.get("/api/v1/admins/" + id)
	},
	
	insertAdmin : (adminData) => {	//관리자 추가
		return api.post("/api/v1/admins", adminData)
	},

	modifyPassword : (adminData) => {	//내 비밀번호 변경
		return api.post("/api/v1/admins/change-password", adminData);
	},
	
	modifyAdmin : (adminData, id) => {	//관리자 수정
		return api.put("/api/v1/admins/" + id , adminData);
	},
	  
	deleteAdmin : (id) => {	//관리자 삭제
		return api.delete("/api/v1/admins/" + id);
	},

	// user
	getUserList : (params) => {	//사용자 정보 조회
		return api.get("/api/v1/users?" + params)
	},

	deleteUser : (id) => {	//사용자 삭제
		return api.delete("/api/v1/users/" + id)
	},

	//device
	getDeviceList : (params) => {	//단말 정보 조회
		return api.get("/api/v1/devices?" + params)
	},

	deleteDevice : (id) => {	//단말 삭제
		return api.delete("/api/v1/devices/" + id);
	},

	//firmware
	getFirmwareList : (params) => {	//펌웨어 목록 조회
		return api.get("/api/v1/firmwares?" + params)
	},
	
	firmwareUpload : (uploadData) => {	//펌웨어 파일 업로드
		return api.post("/api/v1/firmwares", uploadData)
	},

	firmwareDownload : (fileValue) => {	//펌웨어 다운로드
		return api.get("/data/firmwares/" + fileValue, {responseType: 'blob'});
	},

	firmwareDelete : (id) => {	//펌웨어 파일 삭제
		return api.delete("/api/v1/firmwares/" + id);
	},

	//action
	getUserAction : (params) => {	//사용자 이력 조회
		return api.get("/api/v1/histories/user?" + params);
	},

	getDeviceAction : (params) => {	//단말 이력 조회
		return api.get("/api/v1/histories/device?" + params);
	},

	getFirmwareAction : (params) => {	//펌웨어 이력 조회
		return api.get("/api/v1/histories/firmware?" + params);
	},

	getAdminAction : (params) => {	//관리자 이력 조회
		return api.get("/api/v1/histories/admin?" + params);
	},

	getLocationAction : (params) => {	//위치정보제공 이력 조회
		return api.get("/api/v1/histories/loc?" + params);
	},

	//statistics
	getMonthlyData : (params) => {	//월간 통계 항목 및 기준 조회
		return api.get("/api/v1/admins/summary_stats?" + params);
	},

	//board
	getBoardList : (params) => {	//공지사항 목록 조회
		return api.get("/api/v1/notices?" + params)
	},

	insertBoard : (boardData) => {	//공지사항 추가
		return api.post("/api/v1/notices", boardData);
	},

	modifyBoard : (boardData, id) => {	//공지사항 수정
		return api.put("/api/v1/notices/" + id , boardData,);
	},

	deleteBoard : (id) => {	//공지사항 삭제
		return api.delete("/api/v1/notices/" + id);
	},
}
